module.exports = __webpack_public_path__ + "static/media/MasterBed2-1.798f430f.jpg";